import {createReducer} from 'utils/redux';
import {SET_FAVORITE_PICKS, ADD_FAVORITE_PICK, REMOVE_FAVORITE_PICK} from 'actions/favoritePicks';

const initialState = [];

export default createReducer(initialState, {
  [SET_FAVORITE_PICKS]: (state, {payload = initialState}) => payload,
  [ADD_FAVORITE_PICK]: (state, {payload}) => [...state, payload],
  [REMOVE_FAVORITE_PICK]: (state, {payload: pickId}) => state.filter(({id}) => id !== pickId),
});
